import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=2bcdc721&scoped=true"
import script from "./staff.vue?vue&type=script&lang=js"
export * from "./staff.vue?vue&type=script&lang=js"
import style0 from "./staff.vue?vue&type=style&index=0&id=2bcdc721&prod&scoped=true&lang=scss"
import style1 from "./staff.vue?vue&type=style&index=1&id=2bcdc721&prod&scoped=true&lang=scss"
import style2 from "./staff.vue?vue&type=style&index=2&id=2bcdc721&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcdc721",
  null
  
)

export default component.exports